// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Link as RawLink } from "lucide-react";
export const Link = /* @__PURE__ */ createIcon(RawLink, "Link", 2);
